<template>
  <section class="sec-address">
    <div class="module_title">
      <span class="en">{{ en }}</span>
      <span class="num" :class="`num_${index}`" />
      <span class="tit">参会指南</span>
      <span class="en">{{ en }}</span>
    </div>
    <div class="float-bg" />
    <div class="address-main">
      <div class="address-left">
        <img :src="data.img || IMG_LIST.NO_DATA_IMG" alt />
        <div class="address-site">
          <div class="address-area" />
          <div class="address-pos" />
          <div class="address-tit">
            爱奇艺动漫游戏嘉年华
            <div>{{ cityName }}站</div>
          </div>
        </div>
      </div>
      <div class="address-right">
        <div class="address-box">
          <span class="address-title">展会地址</span>
          <div class="address-text" v-html="data.location" />
        </div>
        <div class="right-box">
          <span class="address-title">地铁</span>
          <div class="address-text" v-html="data.subway" />
        </div>
        <div class="left-box">
          <span class="address-title">公交</span>
          <div class="address-text" v-html="data.bus" />
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { IMG_LIST } from '../mock-data'

export default {
  data() {
    return {
      IMG_LIST,
    }
  },
  props: {
    index: {
      type: Number,
      default: 1,
    },
    cityName: {
      type: String,
      default: '',
    },
    en: {
      type: String,
      default: '',
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    data: {
      handler(newValue) {
        this.data.location = newValue.location.replace(/\n/g, '<br/>')
        this.data.subway = newValue.subway.replace(/\n/g, '<br/>')
        this.data.bus = newValue.bus.replace(/\n/g, '<br/>')
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {},
}
</script>
<style lang="less">
.sec-address {
  position: relative;
  max-width: 1090px;
  margin: 0 auto;
  .float-bg {
    left: -195px;
    top: 100px;
    width: 322px;
    height: 153px;
    transform: rotate(-30deg);
  }

  .address-main {
    display: flex;
    margin-top: 48px;

    .address-left {
      position: relative;
      background: #2f15a2;
      width: 634px;
      height: 613px;
      margin-right: 70px;
      flex-shrink: 0;
      &::before {
        position: absolute;
        top: 0;
        bottom: 10px;
        left: 18px;
        right: 0;
        display: block;
        content: '';
        background: #030207;
      }
      &::after {
        position: absolute;
        top: -10px;
        bottom: 26px;
        left: 36px;
        right: -10px;
        display: block;
        content: '';
        background: #ceff1a;
        background: linear-gradient(-45deg, transparent 30px, #ceff1a 0);
      }
    }

    img {
      position: absolute;
      top: -8px;
      left: 38px;
      z-index: 2;
      width: 604px;
      height: 593px;
      clip-path: polygon(0 0, 100% 0, 100% 553px, 563px 100%, 0 100%);
    }

    .address-site {
      position: absolute;
      z-index: 2;
      top: 30%;
      left: 25%;
      .address-area {
        width: 165px;
        height: 200px;
        background: rgba(117, 65, 255, 0.2);
        border: 2px solid #000000;
      }
      .address-pos {
        position: absolute;
        top: 30%;
        left: 60px;
        width: 48px;
        height: 62px;
        background: url('~@/assets/carnival2020/address_pos.png') no-repeat;
        background-size: contain;
      }
      .address-tit {
        position: relative;
        top: -240px;
        left: 100px;
        padding: 5px 50px;
        max-width: 316px;
        text-align: center;
        box-sizing: border-box;
        border: 3px solid #000;
        background: #ceff1a;
        box-shadow: 7px -7px #000;
        color: #000;
        font-size: 20px;
        font-family: HYYakuHei55W;
        font-weight: 600;
        line-height: 30px;
        &::before,
        &::after {
          position: absolute;
          display: inline-block;
          content: '';
        }
        &::before {
          left: -3px;
          bottom: -22px;
          border-top: 20px solid transparent;
          border-bottom: 20px solid transparent;
          border-left: 20px solid black;
          z-index: 1;
        }
        &::after {
          left: 0;
          bottom: -16px;
          border-top: 16px solid transparent;
          border-bottom: 16px solid transparent;
          border-left: 16px solid #ceff1a;
          z-index: 3;
        }
      }
    }
  }

  .address-box,
  .left-box,
  .right-box {
    width: 354px;
    margin-bottom: 95px;
    font-size: 0;
    text-align: left;
    .address-title {
      position: relative;
      top: 5px;

      text-align: center;
      background: #000000;
      line-height: 26px;
      font-family: HYYakuHei55W;
      font-weight: 750;
      font-size: 30px;
      color: #ceff1c;
    }
    .address-text {
      position: relative;
      top: 20px;
      left: 10px;
      padding: 15px 20px;
      font-size: 20px;
      line-height: 34px;
      font-family: HYYakuHei55W;
      box-shadow: -10px -10px #000000;
    }
  }

  .address-box {
    .address-title {
      padding: 7px 10px 3px;
      background: #000000;
      left: 0;
    }
    .address-text {
      padding: 20px 15px 25px;
      background: #7541ff;
      border: 2px solid #000000;
      line-height: 34px;
      text-align: left;
      color: #ffffff;
    }
  }

  .left-box,
  .right-box {
    .address-title {
      padding: 5px 9px 3px 13px;
    }
    .address-text {
      background: #ffffff;
      border: 2px solid #ceff1a;
      color: #030207;
    }
  }

  .right-box {
    text-align: right;
  }
}
</style>
